module.exports = __webpack_public_path__ + "img/Feature.bbf4765a.jpg";